import get from 'lodash.get';

export const selectOcrOrderPdf = (state) => get(state, 'ocrOrderPdf');

export const selectOcrOrderPdfData = (state) => get(state, 'ocrOrderPdf.data');

export const selectSelectedOcrOrderResult = (state) => get(state, 'ocrOrderPdf.selectedJobResult');
